import type { GroupedTxnSummary } from '../constants/api.types';

export type GroupedLedgerRow = {
    date: string;
    deposits: number;
    premium: number;
    refund: number;
    balance: number;
};

const formatDate = (isoString: string): string => {
    const d = new Date(isoString);
    return d.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
};

const getLastTransactionMs = (item: GroupedTxnSummary): number => {
    const raw = item.endTime?.value ?? item.startTime?.value;
    if (!raw) return 0;
    const t = new Date(raw).getTime();
    return Number.isNaN(t) ? 0 : t;
};

const getLastTransactionDateIso = (item: GroupedTxnSummary): string =>
    item.endTime?.value ?? item.startTime?.value ?? '';

export function transformGroupedToLedgerRows(
    grouped: GroupedTxnSummary[]
): GroupedLedgerRow[] {
    const sorted = [...grouped].sort(
        (a, b) => getLastTransactionMs(b) - getLastTransactionMs(a)
    );

    return sorted.map((item) => {
        const premium =
            (item.issuanceAmount?.value ?? 0) +
            (item.endorsementAmount?.value ?? 0);
        const refund =
            (item.accountRefundAmount?.value ?? 0) +
            (item.cancellationAmount?.value ?? 0);
        const deposits = item.depositAmount?.value ?? 0;
        const balance = item.totalBalance?.value ?? 0;

        return {
            date: formatDate(getLastTransactionDateIso(item)),
            deposits,
            premium,
            refund,
            balance,
        };
    });
}
